import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy /orgs URL kept around because Stripe Checkout success URLs that
// were generated before the rename still redirect here. Forwards to the
// new /organizations route preserving query string (e.g., ?setup=success).
export const Route = createFileRoute("/_authenticated/(wonda)/_wonda/orgs/")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/organizations", search });
  },
});
